.ux-static-filter {
  display: block;

  p [data-ux-static-filter] {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &--hidden-items [data-ux-static-filter] {
    opacity: 0;
  }

  &__item {
    &--hidden {
      position: absolute;
      visibility: hidden;
    }
  }
}
